module.exports = __webpack_public_path__ + "static/img/hatchback-orange.46f0e8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-orange.svg
// module id = PXPw
// module chunks = 74